import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../../services/api';

const ROUTES_BY_FLOW = {
  subscriber: 'individual-subscriber',
  auto: 'auto-subscribe',
  company: 'subscribe'
};

const normalizeFlow = (typeForm) => {
  if (typeForm === 'subscriber' || typeForm === 'auto') return typeForm;
  return 'company';
};

export default function FlowGuard({ expectedFlow, children }) {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, error: '' });

  useEffect(() => {
    let active = true;

    async function validateFlow() {
      try {
        const { data } = await api.get(`/events/${eventId}?fields[0]=typeForm&fields[1]=isActive&fields[2]=end_subscription`);
        const configuredFlow = normalizeFlow(data?.typeForm);

        if (!data?.isActive) {
          throw new Error('Evento desativado.');
        }

        if (configuredFlow !== expectedFlow) {
          navigate(`/${ROUTES_BY_FLOW[configuredFlow]}/${eventId}`, { replace: true });
          return;
        }

        if (active) setState({ loading: false, error: '' });
      } catch (error) {
        if (active) {
          setState({
            loading: false,
            error: error.response?.data?.error?.message || error.message || 'Não foi possível validar o fluxo do evento.'
          });
        }
      }
    }

    validateFlow();
    return () => { active = false; };
  }, [eventId, expectedFlow, navigate]);

  if (state.loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
  }

  if (state.error) {
    return <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}><Alert severity="error">{state.error}</Alert></Box>;
  }

  return children;
}
